module.exports = __webpack_public_path__ + "media/mantera_promo_2.aa88bf40.mp4";